<div *ngFor="let contentElement of gridCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
    <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
</div>

<!-- <nb-accordion>
        <nb-accordion-item>
            <nb-accordion-item-header (click)="isClicked()">Standard Features</nb-accordion-item-header>
            <nb-accordion-item-body>
            <div *ngFor="let contentElement of gridCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
            </div>
            </nb-accordion-item-body>
        </nb-accordion-item>
        <nb-accordion-item>
            <nb-accordion-item-header (click)="isClicked()">Dimensions</nb-accordion-item-header>
            <nb-accordion-item-body>
                Testing stuff
            </nb-accordion-item-body>
        </nb-accordion-item>
    </nb-accordion> -->

